module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d4ec3992fc5543c54a79d924c51fa447.png";